export type PlaceholderItem = {
  key: string;
  label: string;
  category: string;
  subcategory?: string;
  description?: string;
  favorite?: boolean;
};

export const PLACEHOLDERS: PlaceholderItem[] = [
  {
    key: "date_today",
    label: "Heutiges Datum",
    category: "Allgemein",
    subcategory: "Statische Werte",
    description: "Aktuelles Datum im Format TT.MM.JJJJ"
  },

  {
    key: "billing_street",
    label: "Straße (Rechnungsadresse)",
    category: "Kontaktdaten",
    subcategory: "Rechnungsadresse"
  },
  {
    key: "billing_code",
    label: "Postleitzahl (Rechnungsadresse)",
    category: "Kontaktdaten",
    subcategory: "Rechnungsadresse"
  },
  {
    key: "billing_city",
    label: "Ort (Rechnungsadresse)",
    category: "Kontaktdaten",
    subcategory: "Rechnungsadresse"
  },
  {
    key: "phone",
    label: "Telefon",
    category: "Kontaktdaten",
    subcategory: "Allgemein"
  },
  {
    key: "zentrale_e_mail",
    label: "Zentrale E-Mail",
    category: "Kontaktdaten",
    subcategory: "Allgemein"
  },
  {
    key: "website",
    label: "Webseite",
    category: "Kontaktdaten",
    subcategory: "Allgemein"
  },
  {
    key: "aufsichtsbehoerde",
    label: "Aufsichtsbehörde",
    category: "Kontaktdaten",
    subcategory: "Behörde"
  },
  {
    key: "telefon_behoerde",
    label: "Telefon Aufsichtsbehörde",
    category: "Kontaktdaten",
    subcategory: "Behörde"
  },

  {
    key: "artikel_komm",
    label: "Artikel Kommune",
    category: "Kommune",
    subcategory: "Basiswerte"
  },
  {
    key: "kommunenart",
    label: "Kommunenart",
    category: "Kommune",
    subcategory: "Basiswerte"
  },
  {
    key: "kommunenname",
    label: "Kommunenname",
    category: "Kommune",
    subcategory: "Basiswerte"
  },

  {
    key: "article_komm_nom",
    label: "Artikel Kommune Nominativ",
    category: "Kommune",
    subcategory: "Artikel"
  },
  {
    key: "article_cap_komm_nom",
    label: "Artikel Kommune Nominativ (groß)",
    category: "Kommune",
    subcategory: "Artikel"
  },
  {
    key: "article_komm_gen",
    label: "Artikel Kommune Genitiv",
    category: "Kommune",
    subcategory: "Artikel"
  },
  {
    key: "article_cap_komm_gen",
    label: "Artikel Kommune Genitiv (groß)",
    category: "Kommune",
    subcategory: "Artikel"
  },
  {
    key: "article_komm_dat",
    label: "Artikel Kommune Dativ",
    category: "Kommune",
    subcategory: "Artikel"
  },
  {
    key: "article_cap_komm_dat",
    label: "Artikel Kommune Dativ (groß)",
    category: "Kommune",
    subcategory: "Artikel"
  },
  {
    key: "article_komm_acc",
    label: "Artikel Kommune Akkusativ",
    category: "Kommune",
    subcategory: "Artikel"
  },
  {
    key: "article_cap_komm_acc",
    label: "Artikel Kommune Akkusativ (groß)",
    category: "Kommune",
    subcategory: "Artikel"
  },

  {
    key: "kommunenart_nom",
    label: "Kommunenart Nominativ",
    category: "Kommune",
    subcategory: "Kommunenart"
  },
  {
    key: "kommunenart_gen",
    label: "Kommunenart Genitiv",
    category: "Kommune",
    subcategory: "Kommunenart"
  },
  {
    key: "kommunenart_dat",
    label: "Kommunenart Dativ",
    category: "Kommune",
    subcategory: "Kommunenart"
  },
  {
    key: "kommunenart_acc",
    label: "Kommunenart Akkusativ",
    category: "Kommune",
    subcategory: "Kommunenart"
  },

  {
    key: "kommune",
    label: "Kommune (Basisphrase)",
    category: "Kommune",
    subcategory: "Phrase"
  },
  {
    key: "kommune_nom",
    label: "Kommune Nominativ",
    category: "Kommune",
    subcategory: "Phrase"
  },
  {
    key: "kommune_gen",
    label: "Kommune Genitiv",
    category: "Kommune",
    subcategory: "Phrase"
  },
  {
    key: "kommune_dat",
    label: "Kommune Dativ",
    category: "Kommune",
    subcategory: "Phrase"
  },
  {
    key: "kommune_acc",
    label: "Kommune Akkusativ",
    category: "Kommune",
    subcategory: "Phrase"
  },
  {
    key: "kommune_cap_nom",
    label: "Kommune Nominativ (groß)",
    category: "Kommune",
    subcategory: "Phrase"
  },
  {
    key: "kommune_cap_gen",
    label: "Kommune Genitiv (groß)",
    category: "Kommune",
    subcategory: "Phrase"
  },
  {
    key: "kommune_cap_dat",
    label: "Kommune Dativ (groß)",
    category: "Kommune",
    subcategory: "Phrase"
  },
  {
    key: "kommune_cap_acc",
    label: "Kommune Akkusativ (groß)",
    category: "Kommune",
    subcategory: "Phrase"
  },

  {
    key: "kommune_has_plural",
    label: "Kommune ist Plural",
    category: "Kommune",
    subcategory: "Grammatik"
  },
  {
    key: "kommune_haben_hat",
    label: "Verbform haben/hat",
    category: "Kommune",
    subcategory: "Grammatik"
  },
  {
    key: "kommune_sind_ist",
    label: "Verbform sind/ist",
    category: "Kommune",
    subcategory: "Grammatik"
  },
  {
    key: "praep_komm_von_dat",
    label: "Präposition von + Dativ",
    category: "Kommune",
    subcategory: "Grammatik"
  },
  {
    key: "praep_komm_bei_dat",
    label: "Präposition bei + Dativ",
    category: "Kommune",
    subcategory: "Grammatik"
  },

  {
    key: "artikel_il",
    label: "Artikel Institutionsleitung",
    category: "Institutionsleitung",
    subcategory: "Basiswerte"
  },
  {
    key: "institutionsleitung",
    label: "Institutionsleitung",
    category: "Institutionsleitung",
    subcategory: "Basiswerte"
  },

  {
    key: "article_il_nom",
    label: "Artikel Institutionsleitung Nominativ",
    category: "Institutionsleitung",
    subcategory: "Artikel"
  },
  {
    key: "article_cap_il_nom",
    label: "Artikel Institutionsleitung Nominativ (groß)",
    category: "Institutionsleitung",
    subcategory: "Artikel"
  },
  {
    key: "article_il_gen",
    label: "Artikel Institutionsleitung Genitiv",
    category: "Institutionsleitung",
    subcategory: "Artikel"
  },
  {
    key: "article_cap_il_gen",
    label: "Artikel Institutionsleitung Genitiv (groß)",
    category: "Institutionsleitung",
    subcategory: "Artikel"
  },
  {
    key: "article_il_dat",
    label: "Artikel Institutionsleitung Dativ",
    category: "Institutionsleitung",
    subcategory: "Artikel"
  },
  {
    key: "article_cap_il_dat",
    label: "Artikel Institutionsleitung Dativ (groß)",
    category: "Institutionsleitung",
    subcategory: "Artikel"
  },
  {
    key: "article_il_acc",
    label: "Artikel Institutionsleitung Akkusativ",
    category: "Institutionsleitung",
    subcategory: "Artikel"
  },
  {
    key: "article_cap_il_acc",
    label: "Artikel Institutionsleitung Akkusativ (groß)",
    category: "Institutionsleitung",
    subcategory: "Artikel"
  },

  {
    key: "institutionsleitung_nom",
    label: "Institutionsleitung Nominativ",
    category: "Institutionsleitung",
    subcategory: "Nomen"
  },
  {
    key: "institutionsleitung_gen",
    label: "Institutionsleitung Genitiv",
    category: "Institutionsleitung",
    subcategory: "Nomen"
  },
  {
    key: "institutionsleitung_dat",
    label: "Institutionsleitung Dativ",
    category: "Institutionsleitung",
    subcategory: "Nomen"
  },
  {
    key: "institutionsleitung_acc",
    label: "Institutionsleitung Akkusativ",
    category: "Institutionsleitung",
    subcategory: "Nomen"
  },

  {
    key: "il_nom",
    label: "Institutionsleitung Phrase Nominativ",
    category: "Institutionsleitung",
    subcategory: "Phrase",
  },
  {
    key: "il_gen",
    label: "Institutionsleitung Phrase Genitiv",
    category: "Institutionsleitung",
    subcategory: "Phrase"
  },
  {
    key: "il_dat",
    label: "Institutionsleitung Phrase Dativ",
    category: "Institutionsleitung",
    subcategory: "Phrase"
  },
  {
    key: "il_acc",
    label: "Institutionsleitung Phrase Akkusativ",
    category: "Institutionsleitung",
    subcategory: "Phrase"
  },
  {
    key: "il_cap_nom",
    label: "Institutionsleitung Phrase Nominativ (groß)",
    category: "Institutionsleitung",
    subcategory: "Phrase"
  },
  {
    key: "il_cap_gen",
    label: "Institutionsleitung Phrase Genitiv (groß)",
    category: "Institutionsleitung",
    subcategory: "Phrase"
  },
  {
    key: "il_cap_dat",
    label: "Institutionsleitung Phrase Dativ (groß)",
    category: "Institutionsleitung",
    subcategory: "Phrase"
  },
  {
    key: "il_cap_acc",
    label: "Institutionsleitung Phrase Akkusativ (groß)",
    category: "Institutionsleitung",
    subcategory: "Phrase"
  },

  {
    key: "institutionsleitung_signature",
    label: "Institutionsleitung Unterschrift",
    category: "Institutionsleitung",
    subcategory: "Sonderwerte",
  },

  {
    key: "poss_buerger",
    label: "Possessivform Bürger",
    category: "Sonstige",
    subcategory: "Glossar"
  },
  {
    key: "anrede_asp_is",
    label: "Anrede Ansprechpartner Informationssicherheit",
    category: "Informationssicherheit",
    subcategory: "Ansprechpartner",
    description: "Anrede der Ansprechperson für Informationssicherheit, z. B. Herr oder Frau"
  },
  {
    key: "berater_isb",
    label: "Name Berater Informationssicherheitsbeauftragter",
    category: "Informationssicherheit",
    subcategory: "Berater",
    description: "Name des Beraters bzw. der Beraterin für Informationssicherheit"
  },
  {
    key: "berater_dsb",
    label: "Name Berater Datenschutzbeauftragter",
    category: "Datenschutz",
    subcategory: "Berater",
    description: "Name des Beraters bzw. der Beraterin für Datenschutz"
  },

  {
    key: "article_zu_komm_dat",
    label: "Präposition zu + Dativ",
    category: "Kommune",
    subcategory: "Grammatik",
    description: "Verschmolzene Form von zu mit dem bestimmten Artikel der Kommune im Dativ, z. B. zur, zum oder zu den"
  },
  {
    key: "article_zu_komm_dat_cap",
    label: "Präposition zu + Dativ (groß)",
    category: "Kommune",
    subcategory: "Grammatik",
    description: "Wie article_zu_komm_dat, aber mit großem Anfangsbuchstaben für Satzanfänge"
  },

  {
    key: "name_institutionsleitung",
    label: "Name Institutionsleitung",
    category: "Institutionsleitung",
    subcategory: "Basiswerte",
    description: "Name der Institutionsleitung"
  },

  {
    key: "possessive_komm_gen",
    label: "Possessivpronomen Kommune Genitiv",
    category: "Kommune",
    subcategory: "Grammatik",
    description: "Passendes Possessivpronomen der Kommune im Genitiv, z. B. ihrer oder seiner"
  },
  {
    key: "possessive_komm_gen_cap",
    label: "Possessivpronomen Kommune Genitiv (groß)",
    category: "Kommune",
    subcategory: "Grammatik",
    description: "Wie possessive_komm_gen, aber mit großem Anfangsbuchstaben für Satzanfänge"
  },

  {
    key: "noun_komm_nom",
    label: "Beschäftigter/Beschäftigte",
    category: "Kommune",
    subcategory: "Grammatik",
    description: "Geschlechtsabhängige Form Beschäftigter oder Beschäftigte"
  },
  {
    key: "pers_komm_nom",
    label: "Pronomen Kommune Nominativ",
    category: "Kommune",
    subcategory: "Grammatik",
    description: "Subjektpronomen passend zur Form, z. B. er oder sie"
  },
  {
    key: "pers_komm_nom_cap",
    label: "Pronomen Kommune Nominativ (groß)",
    category: "Kommune",
    subcategory: "Grammatik",
    description: "Wie pers_komm_nom, aber mit großem Anfangsbuchstaben für Satzanfänge"
  },
  {
    key: "demo_komm_nom",
    label: "Demonstrativpronomen Kommune Nominativ",
    category: "Kommune",
    subcategory: "Grammatik",
    description: "Passende Form des Demonstrativpronomens, z. B. diese oder diesen"
  },
  {
    key: "demo_komm_nom_cap",
    label: "Demonstrativpronomen Kommune Nominativ (groß)",
    category: "Kommune",
    subcategory: "Grammatik",
    description: "Wie demo_komm_nom, aber mit großem Anfangsbuchstaben für Satzanfänge"
  },
  {
    key: "poss_komm_nom",
    label: "Possessivpronomen Kommune Nominativ",
    category: "Kommune",
    subcategory: "Grammatik",
    description: "Passendes Possessivpronomen der Kommune, z. B. ihre oder seine"
  },
  {
    key: "poss_komm_nom_cap",
    label: "Possessivpronomen Kommune Nominativ (groß)",
    category: "Kommune",
    subcategory: "Grammatik",
    description: "Wie poss_komm_nom, aber mit großem Anfangsbuchstaben für Satzanfänge"
  },

  {
    key: "ist_namen",
    label: "Namen Informationssicherheitsteam",
    category: "Informationssicherheit",
    subcategory: "Team",
    description: "Namen des Informationssicherheitsteams, untereinander dargestellt"
  },
  {
    key: "ist_rollen",
    label: "Rollen Informationssicherheitsteam",
    category: "Informationssicherheit",
    subcategory: "Team",
    description: "Rollen des Informationssicherheitsteams, untereinander dargestellt"
  },
  {
    key: "name_asp_is_komm",
    label: "Name Ansprechpartner Informationssicherheit Kommune",
    category: "Informationssicherheit",
    subcategory: "Ansprechpartner",
    description: "Name der Ansprechperson für Informationssicherheit auf Kundenseite"
  },

  {
    key: "prep_in_komm",
    label: "Präposition in/im",
    category: "Kommune",
    subcategory: "Grammatik",
    description: "Passende Form von in oder im abhängig vom Artikel der Kommune"
  },
  {
    key: "prep_in_komm_cap",
    label: "Präposition in/im (groß)",
    category: "Kommune",
    subcategory: "Grammatik",
    description: "Wie prep_in_komm, aber mit großem Anfangsbuchstaben für Satzanfänge"
  },
  {
    key: "prep_von_komm_cap",
    label: "Präposition von/vom (groß)",
    category: "Kommune",
    subcategory: "Grammatik",
    description: "Passende Form von von der, von den oder vom mit großem Anfangsbuchstaben"
  },
  {
    key: "prep_bei_komm_cap",
    label: "Präposition bei/beim (groß)",
    category: "Kommune",
    subcategory: "Grammatik",
    description: "Passende Form von bei der, bei den oder beim mit großem Anfangsbuchstaben"
  },

  {
    key: "besitzt_besitzen",
    label: "Verbform besitzt/besitzen",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "verfolgt_verfolgen",
    label: "Verbform verfolgt/verfolgen",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "wird_werden",
    label: "Verbform wird/werden",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "eroeffnet_eroeffnen",
    label: "Verbform eröffnet/eröffnen",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "verfuegt_verfuegen",
    label: "Verbform verfügt/verfügen",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "stellt_stellen",
    label: "Verbform stellt/stellen",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "unterliegt_unterliegen",
    label: "Verbform unterliegt/unterliegen",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "dient_dienen",
    label: "Verbform dient/dienen",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "setzt_setzen",
    label: "Verbform setzt/setzen",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "kann_koennen",
    label: "Verbform kann/können",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "muss_muessen",
    label: "Verbform muss/müssen",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "definiert_definieren",
    label: "Verbform definiert/definieren",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "haelt_halten",
    label: "Verbform hält/halten",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "verbietet_verbieten",
    label: "Verbform verbietet/verbieten",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "verwendet_verwenden",
    label: "Verbform verwendet/verwenden",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "orientiert_orientieren",
    label: "Verbform orientiert/orientieren",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "verabschiedet_verabschieden",
    label: "Verbform verabschiedet/verabschieden",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "bekennt_bekennen",
    label: "Verbform bekennt/bekennen",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "moechte_moechten",
    label: "Verbform möchte/möchten",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "benennt_benennen",
    label: "Verbform benennt/benennen",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },
  {
    key: "traegt_tragen",
    label: "Verbform trägt/tragen",
    category: "Kommune",
    subcategory: "Verbformen",
    description: "Passende Verbform abhängig davon, ob die Kommune grammatisch im Singular oder Plural steht"
  },

  {
    key: "anrede_ds_asp",
    label: "Anrede Datenschutz-Ansprechpartner",
    category: "Datenschutz",
    subcategory: "Ansprechpartner",
    description: "Anrede des Datenschutz-Ansprechpartners, z. B. Herr oder Frau"
  },
  {
    key: "actago_ds_asp",
    label: "actago Datenschutz-Ansprechpartner",
    category: "Datenschutz",
    subcategory: "Ansprechpartner",
    description: "Wert aus dem CRM-Feld actago_DS_ASP"
  },
  {
    key: "rolle_ds_asp",
    label: "Rolle Datenschutz-Ansprechpartner",
    category: "Datenschutz",
    subcategory: "Ansprechpartner",
    description: "Rolle des Datenschutz-Ansprechpartners"
  },

  {
    key: "dsb_cap_komm_nom",
    label: "Artikel Datenschutzbeauftragter Nominativ (groß)",
    category: "Datenschutz",
    subcategory: "Grammatik",
    description: "Passender bestimmter Artikel für den Datenschutzbeauftragten im Nominativ mit großem Anfangsbuchstaben, also Der oder Die"
  },
  {
    key: "dsb_komm_nom",
    label: "Artikel Datenschutzbeauftragter Nominativ",
    category: "Datenschutz",
    subcategory: "Grammatik",
    description: "Passender bestimmter Artikel für den Datenschutzbeauftragten im Nominativ, also der oder die"
  },
  {
    key: "dsb_gen",
    label: "Artikel Datenschutzbeauftragter Genitiv",
    category: "Datenschutz",
    subcategory: "Grammatik",
    description: "Passender bestimmter Artikel für den Datenschutzbeauftragten im Genitiv, also des oder der"
  },

  {
    key: "article_isb_gen",
    label: "Artikel Informationssicherheitsbeauftragter Genitiv",
    category: "Informationssicherheit",
    subcategory: "Grammatik",
    description: "Passender bestimmter Artikel für den Informationssicherheitsbeauftragten im Genitiv, also des oder der"
  },
  {
    key: "article_isb_nom",
    label: "Artikel Informationssicherheitsbeauftragter Nominativ",
    category: "Informationssicherheit",
    subcategory: "Grammatik",
    description: "Passender bestimmter Artikel für den Informationssicherheitsbeauftragten im Nominativ, also der oder die"
  },
  {
    key: "die_den_isb",
    label: "Artikel Informationssicherheitsbeauftragter Akkusativ",
    category: "Informationssicherheit",
    subcategory: "Grammatik",
    description: "Passender bestimmter Artikel für den Informationssicherheitsbeauftragten im Akkusativ, also die oder den"
  },
  {
    key: "die_der_isb_cap",
    label: "Artikel Informationssicherheitsbeauftragter Nominativ (groß)",
    category: "Informationssicherheit",
    subcategory: "Grammatik",
    description: "Passender bestimmter Artikel für den Informationssicherheitsbeauftragten im Nominativ mit großem Anfangsbuchstaben, also Die oder Der"
  },

  {
    key: "ihr_ihre_il_cap",
    label: "Possessivform Institutionsleitung (groß)",
    category: "Institutionsleitung",
    subcategory: "Grammatik",
    description: "Passende Possessivform vor der Institutionsleitung mit großem Anfangsbuchstaben, z. B. Sein oder Ihre"
  },
  {
    key: "ihrer_seiner_vertretenden",
    label: "Possessivform Vertretende im Amt",
    category: "Institutionsleitung",
    subcategory: "Grammatik",
    description: "Passende Possessivform im Kontext der Vertretung der Institutionsleitung, z. B. seinen oder ihren Vertretenden im Amt"
  },

  {
    key: "anwendungsbereich_IS_eingeschlossen",
    label: "Anwendungsbereich IS eingeschlossen",
    category: "Informationssicherheit",
    subcategory: "Anwendungsbereich",
    description: "Gültiger bzw. eingeschlossener Anwendungsbereich für Informationssicherheit"
  },
  {
    key: "anwendungsbereich_IS_abgegrenzt",
    label: "Anwendungsbereich IS abgegrenzt",
    category: "Informationssicherheit",
    subcategory: "Anwendungsbereich",
    description: "Ausgeschlossener bzw. abgegrenzter Anwendungsbereich für Informationssicherheit"
  },
  {
    key: "anwendungsbereich_DS_eingeschlossen",
    label: "Anwendungsbereich Datenschutz eingeschlossen",
    category: "Datenschutz",
    subcategory: "Anwendungsbereich",
    description: "Gültiger bzw. eingeschlossener Anwendungsbereich für Datenschutz"
  },
  {
    key: "anwendungsbereich_DS_abgegrenzt",
    label: "Anwendungsbereich Datenschutz abgegrenzt",
    category: "Datenschutz",
    subcategory: "Anwendungsbereich",
    description: "Ausgeschlossener bzw. abgegrenzter Anwendungsbereich für Datenschutz"
  },
  {
    key: "vw_cap_gen",
    label: "Verantwortlicher Genitiv (groß)",
    category: "Datenschutz",
    subcategory: "Grammatik",
    description: "Fester Wert: Des Verantwortlichen"
  },
  {
    key: "vw_gen",
    label: "Verantwortlicher Genitiv",
    category: "Datenschutz",
    subcategory: "Grammatik",
    description: "Fester Wert: des Verantwortlichen"
  },
  {
    key: "kunden_version",
    label: "Kundenversion",
    category: "Allgemein",
    subcategory: "Version",
    description: "Version des Kundendokuments"
  }
];